import { Fragment, useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { apiEndpoint } from './constants/api';
import { JobSearchTable } from './components/JobSearchTable';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: state.user.currentEmployer
}), {});
function JobSearch({ user, employer }) {
  const [jobData, setJobData] = useState([]);
  const [query, setQuery] = useState('');
  const [searching, setSearching] = useState(false);
  const timeout = useRef();

  const onSubmit = (evt) => {
    evt.preventDefault();
  }

  const findJobData = async ({ target: { value } }) => {
    setSearching(true);
    clearTimeout(timeout.current);
    setQuery(value);
    timeout.current = setTimeout(() => loadJobData(value), 700);
  };

  const loadJobData = async (q) => {
    const { data } = await axios.post(apiEndpoint('/search/jobs'), { q, employer });
    setJobData(data);
    setSearching(false);
  };

  useEffect(() => {
    loadJobData();
  }, [employer]);

  return (
    <>
    <Helmet>
      <title>Job Search | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="pb-2">
                  <div className="flex pb-2">
                    <div className="flex justify-end">
                      <a
                        href="/admin/job-posting"
                        class="flex items-center p-2 text-base font-normal text-gray-400 rounded-lg text-white bg-blue-600 hover:bg-gray-700"
                      >
                        <svg
                          aria-hidden="true"
                          className="w-6 h-6 text-white transition duration-75 group-hover:text-white"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd"></path>
                        </svg>
                        <span class="ml-3">Job Posting</span>
                      </a>
                    </div>
                  </div>
                  <form onSubmit={onSubmit}>
                    <label
                      htmlFor="job-search"
                      className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                      Search
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <svg
                          aria-hidden="true"
                          className="w-5 h-5 text-gray-500 dark:text-gray-400"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                          ></path>
                        </svg>
                      </div>
                      <input
                        onChange={findJobData}
                        type="search"
                        id="job-search"
                        className="block w-full p-6 px-10 text-lg text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        placeholder="Search Jobs..."
                        required
                      />
                    </div>
                  </form>
                </div>
                {(jobData && jobData.length) || searching ? (
                  searching ? (<div className="w-full"><div className="mx-auto">Loading Jobs...</div></div>)
                  : <JobSearchTable jobData={jobData} searching={searching} />
                ) : (
                  <div className="text-center bg-blue-50 rounded-lg border-2 py-3">
                  <div className="text-xl hover:text-underline bold">Productions.com Support Specialist</div>
                  <div>We are going to help you setup your first job!</div>
                  <div>Expect an email from us...See you soon!</div>
                  </div>
                )}
              </div>
              {/* /End replace */}
            </div>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(JobSearch)